"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextBubbleCSS = void 0;
const tslib_1 = require("tslib");
const defaultStyles = tslib_1.__importStar(require("./styles/default"));
const arcanaStyles = tslib_1.__importStar(require("./styles/arcana"));
const GameUIStyle_1 = require("../../models/GameUIStyle");
class TextBubbleCSS {
    static getDialogueCSSByAlias(alias) {
        switch (alias.toLowerCase()) {
            case GameUIStyle_1.GameUIStyle.Arcana:
                return arcanaStyles.dialogue;
            default:
                return defaultStyles.dialogue;
        }
    }
    static getChoiceAnswerCSSByAlias(alias) {
        switch (alias.toLowerCase()) {
            case GameUIStyle_1.GameUIStyle.Arcana:
                return arcanaStyles.choiceAnswer;
            default:
                return defaultStyles.choiceAnswer;
        }
    }
    static getCommentsButtonCSSByAlias(alias) {
        switch (alias.toLowerCase()) {
            case GameUIStyle_1.GameUIStyle.Arcana:
                return arcanaStyles.commentsButton;
            default:
                return defaultStyles.commentsButton;
        }
    }
    static getDropoffAnalyticsCSSByAlias(alias) {
        switch (alias.toLowerCase()) {
            case 'arcana':
                return arcanaStyles.dropoffAnalyticsCSS;
            default:
                return defaultStyles.dropoffAnalyticsCSS;
        }
    }
}
exports.TextBubbleCSS = TextBubbleCSS;
